import { render, staticRenderFns } from "./PermitsOdol.vue?vue&type=template&id=6213de9d&"
import script from "./PermitsOdol.vue?vue&type=script&lang=js&"
export * from "./PermitsOdol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports